import { DataSource } from '@angular/cdk/table';
import { Observable, of as observableOf } from 'rxjs';
import { PrintJob } from 'src/app/domain/printJob/print-job';
import { PrintJobService } from 'src/app/domain/printJob/print-job-service.service';

export class PrintJobTableDataSource extends DataSource<PrintJob> {
    data: PrintJob[] = [];

    constructor(private printJobService: PrintJobService) {
        super();
    }

    connect(): Observable<PrintJob[]> {
        return observableOf(this.data);
    }
    disconnect() { }

    getPrintJobs(printerName: string, printQueueState: string) {
        this.printJobService.getPrintJobs(printerName, printQueueState)
        .subscribe(
            (p) => this.data = p,
            (err) => console.error(err)
        );
    }
}
